(() => {
  const cfg = window.__FREE_GIFT__;
  if (!cfg || !cfg.enabled) return;

  const root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const CART_JSON = `${root}cart.js`;
  const ADD = `${root}cart/add.js`;
  const CHANGE = `${root}cart/change.js`;

  let isProcessing = false;
  let debounceTimer = null;

  const debounce = (fn, wait = 250) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fn, wait);
  };

  const fetchCart = async () => {
    const res = await fetch(CART_JSON, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  };

  const postJSON = async (url, body) => {
    const res = await fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(`Cart request failed: ${res.status} ${txt}`);
    }
    return res.json().catch(() => ({}));
  };

  const getQualifyingQty = (cart) => {
    const qId = Number(cfg.qualifyingProductId);
    let qty = 0;
    for (const item of cart.items || []) {
      if (Number(item.product_id) === qId) qty += Number(item.quantity || 0);
    }
    return qty;
  };

  const findGiftItem = (cart) => {
    const gProdId = Number(cfg.giftProductId);
    const gVarId = Number(cfg.giftVariantId);
    return (cart.items || []).find(
      (it) => Number(it.product_id) === gProdId || Number(it.variant_id) === gVarId
    );
  };

  const refreshMinimogUI = () => {
    // Cart Drawer
    const drawer = document.querySelector("m-cart-drawer");
    if (drawer && typeof drawer.onCartDrawerUpdate === "function") {
      drawer.onCartDrawerUpdate(true);
    }

    // Cart page (se existir um "cart-items" custom element padrão minimog)
    const cartItemsEl = document.querySelector("cart-items");
    if (cartItemsEl && typeof cartItemsEl.onCartUpdate === "function") {
      cartItemsEl.onCartUpdate();
    }

    // fallback leve: tenta disparar evento que alguns temas escutam
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  };

  const lockGiftQtyUI = () => {
    const gProdId = String(cfg.giftProductId);

    const roots = document.querySelectorAll(
      `[data-product-id="${gProdId}"], [data-cart-item-product-id="${gProdId}"]`
    );

    roots.forEach((rootEl) => {
      rootEl.classList.add("is-free-gift");

      // desabilita input qty
      rootEl
        .querySelectorAll('input[name="updates[]"], input[type="number"]')
        .forEach((inp) => {
          inp.setAttribute("disabled", "disabled");
          inp.setAttribute("readonly", "readonly");
        });

      // desabilita botões +/-
      rootEl
        .querySelectorAll(
          'button[name="minus"], button[name="plus"], .m-quantity__button, .quantity__button, [data-qty-minus], [data-qty-plus]'
        )
        .forEach((btn) => {
          btn.setAttribute("disabled", "disabled");
          btn.setAttribute("aria-disabled", "true");
          btn.style.pointerEvents = "none";
        });
    });
  };

  const ensureGift = async () => {
    await postJSON(ADD, {
      items: [
        {
          id: Number(cfg.giftVariantId),
          quantity: 1,
          properties: { _free_gift: "true" },
        },
      ],
    });
  };

  const removeGift = async (giftItem) => {
    await postJSON(CHANGE, { id: giftItem.key, quantity: 0 });
  };

  const syncFreeGift = async () => {
    if (isProcessing) return;

    isProcessing = true;
    try {
      const cart = await fetchCart();
      const qualifyingQty = getQualifyingQty(cart);
      const giftItem = findGiftItem(cart);
      const shouldHaveGift =
        qualifyingQty >= Number(cfg.qualifyingMinQty || 2);

      if (shouldHaveGift && !giftItem) {
        await ensureGift();
        refreshMinimogUI();
      } else if (!shouldHaveGift && giftItem) {
        await removeGift(giftItem);
        refreshMinimogUI();
      }

      setTimeout(lockGiftQtyUI, 350);
    } catch (e) {
      console.error("[FreeGift] Sync error:", e);
    } finally {
      isProcessing = false;
    }
  };

  // =========================
  // 1) PRIMEIRA EXECUÇÃO
  // =========================
  document.addEventListener("DOMContentLoaded", () => {
    syncFreeGift();
    setTimeout(lockGiftQtyUI, 450);
  });

  // =========================
  // 2) INTERCEPTA FETCH
  // =========================
  const _fetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await _fetch(...args);

    try {
      const url =
        typeof args[0] === "string"
          ? args[0]
          : (args[0] && args[0].url) || "";

      if (
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear")
      ) {
        debounce(syncFreeGift, 150);
      }
    } catch (_) {}

    return res;
  };

  // =========================
  // 3) INTERCEPTA XHR (MUITO IMPORTANTE)
  // =========================
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__freeGiftURL = url || "";
    return _open.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (body) {
    try {
      this.addEventListener("loadend", () => {
        const url = this.__freeGiftURL || "";
        if (
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update") ||
          url.includes("/cart/clear")
        ) {
          debounce(syncFreeGift, 150);
        }
      });
    } catch (_) {}
    return _send.call(this, body);
  };

  // =========================
  // 4) ESCUTA INTERAÇÕES DE UI (PLUS/MINUS/INPUT)
  // =========================
  const uiHandler = (e) => {
    const t = e.target;
    if (
      t.closest(".m-quantity__button") ||
      t.closest('button[name="plus"]') ||
      t.closest('button[name="minus"]') ||
      (t.matches && t.matches('input[name="updates[]"], input[type="number"]'))
    ) {
      debounce(syncFreeGift, 200);
    }
  };

  document.addEventListener("click", uiHandler, true);
  document.addEventListener("change", uiHandler, true);

  // =========================
  // 5) OBSERVA MUDANÇAS NO DRAWER/CART (re-render via sections)
  // =========================
  const observeTargets = () => {
    const targets = [
      document.querySelector("[data-minimog-cart-items]"),
      document.querySelector("#MinimogCartDrawerFooter"),
      document.querySelector("main"), // fallback
    ].filter(Boolean);

    targets.forEach((target) => {
      const obs = new MutationObserver(() => {
        debounce(() => {
          lockGiftQtyUI();
          // e se re-renderou, garante que a regra continue consistente
          syncFreeGift();
        }, 250);
      });

      obs.observe(target, { childList: true, subtree: true });
    });
  };

  observeTargets();

  // bônus: ao abrir drawer, força sync
  document.addEventListener("click", (e) => {
    if (e.target.closest(".m-cart-icon-bubble")) {
      setTimeout(() => {
        syncFreeGift();
        lockGiftQtyUI();
      }, 350);
    }
  });
})();